import { create } from 'zustand';

type ChatbotsPageStore = {
  isCreateDialogOpen: boolean;
  openCreateDialog: () => void;
  closeCreateDialog: () => void;
};

export const useChatbotsPageStore = create<ChatbotsPageStore>((set) => ({
  isCreateDialogOpen: false,
  openCreateDialog: () => set({ isCreateDialogOpen: true }),
  closeCreateDialog: () => set({ isCreateDialogOpen: false }),
}));
